module.exports = __webpack_public_path__ + "img/dnjoy.2b527c40.png";